import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, CircularProgress } from '@mui/material';
import { StyledLogo, CenteredSquare, LoadingContainer, LogoContainer, LogoutContainer, } from './style';
import { useTypedTheme } from '@monorepo-web/styles';
import BotaoLogout from '../BotaoUser/BotaoLogout';
const LoadingPageComponent = ({ handleLogout, LogoLogin, LogoLoginMarginBottom, LogoLoginScale }) => {
    const theme = useTypedTheme();
    return (_jsxs(LoadingContainer, { children: [_jsx(LogoutContainer, { children: _jsx(BotaoLogout, { handleLogout: handleLogout, sx: {
                        backgroundColor: theme.loginButtonBgc,
                        color: theme.loginButtonColor,
                        padding: '12px 12px',
                        borderRadius: 2,
                        '&:hover': {
                            backgroundColor: `${theme.loginButtonBgc}cc`
                        }
                    } }) }), _jsxs(CenteredSquare, { children: [_jsx(LogoContainer, Object.assign({ marginBottom: LogoLoginMarginBottom }, { children: _jsx(StyledLogo, { src: LogoLogin || '', scale: LogoLoginScale }) })), _jsx(Grid, Object.assign({ container: true, justifyContent: "center", style: { marginTop: 16 } }, { children: _jsx(CircularProgress, { sx: { color: theme.loginColor }, size: 128 }) }))] })] }));
};
export default LoadingPageComponent;
